module.exports = __webpack_public_path__ + "img/icon-error--white.e63f4aea.svg";